import { useTranslation } from "react-i18next";
import FoundationEn from "@/agreement/foundation-en.jsx";
import FoundationKo from "@/agreement/foundation-ko.jsx";
import enImage from "@/assets/img/consortium/en.png";
import krImage from "@/assets/img/consortium/kr.png";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import "@/assets/sass/introduction-consortium.scss";
const NextIcon = () => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.1332 7.98372L5.0332 4.88372L6.26654 3.65039L10.5999 7.98372L6.26654 12.3171L5.0332 11.0837L8.1332 7.98372Z" fill="#576059" />
</svg>

function PrivacyPolicy(props) {
  const [activeTab, setActiveTab] = useState(0)
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { hash } = useLocation();

  const foundlink = (link, t) => {
    setActiveTab(t)
    navigate("/introduction-consortium"+link);
  };

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  return (
    <div className="introduction-consortium">
      {/* End Header Section */}
      {/*}
      <div className="cs-height_90 cs-height_lg_80"></div>
      {*/}
      {/* Start Page Head */}
      <div dangerouslySetInnerHTML={{ __html: "<style>html,body{height:100%}</style>" }}></div>

      <section
        className="cs-page_head cs-bg"
        style={{ backgroundImage: "url(/assets/img/foundation.jpg)", height: "338px", display: "flex", alignItems: "center" }}
      >
        <div className="container">
          <div className="text-center">
            <h1
              className="cs-page_title gmarket"
              style={{
                position: "relative",
                fontSize: 40,
                color: "white",
                fontWeight: "bold"
              }}
            >
              {t("abouttheFoundation")}
            </h1>
          </div>
        </div>
      </section>
      {/* End Page Head */}
      {/*}
      <div className="cs-height_100 cs-height_lg_70"></div>
      {*/}
      <div className="foundation-container container">
        
        <div className="left-sticky">
          <div className="navs-menus">
            <div className="title"> {t("abouttheFoundation")}</div>
            <ul className="navs-list">
              <li className={"navs-item " + (activeTab == 0 ? 'active' : '')} onClick={() => foundlink('#A1',0)}>
                <div className="navs-label">
                  <span>{t("foundationpurpose")}</span>
                  <NextIcon />
                </div>
              </li>
              <li className={"navs-item " + (activeTab == 1 ? 'active' : '')} onClick={() => foundlink('#A2',1)}>
                <div className="navs-label">
                  <span>{t("carbonmarket")}</span>
                  <NextIcon />
                </div>
              </li>
              <li className={"navs-item " + (activeTab == 2 ? 'active' : '')} onClick={() => foundlink('#A3',2)}>
                <div className="navs-label">
                  <span>{t("messagechairman")}</span>
                  <NextIcon />
                </div>
              </li>
              <li className={"navs-item " + (activeTab == 3 ? 'active' : '')} onClick={() => foundlink('#A4',3)}>
                <div className="navs-label">
                  <span>{t("history")}</span>
                  <NextIcon />
                </div>
              </li>
              <li className={"navs-item " + (activeTab == 4 ? 'active' : '')} onClick={() => foundlink('#A5',4)}>
                <div className="navs-label">
                  <span>{t("organizationChart")}</span>
                  <NextIcon />
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/*}<div className="container-foundation"></div>{*/}
        {/*}<div className="row">{*/}
           {props.language == "ko" && (
              <div className="page-content">
                <section id="A1">
                  <div className="fd_con_title">
                    <h3 className="fd_con_title_h3">
                      <div class="min-titlef-blue"></div>재단 설립 목적과 비전
                    </h3>
                  </div>
                  <p className="fd_con_title_subtit">기후 변화 대응, 더 이상 선택이 아닌 필수</p>

                  <div className="fd_con_bgpanel">
                    <div className="fd_con_pn_desc">
                      기후 문제는 인류가 직면한 가장 심각한 도전 과제 입니다.
                      기후가 변화한다는 관망자적 관심에서, 이제는 기후가 재난을 일으킨다는 적극적 인식과 실천이 필요한 때입니다.<br/>
                      인류의 넷 제로(Net-Zero) 선언은 기후 종말 도래 시기를 지연시킬 뿐, 문제 해결을 위한 근본적인 수단이 되지 못합니다.
                      넷 제로를 넘어 적극적인 카본 네거티브(Carbon Negative)를 통해 대기 중 온실가스 농도를 산업혁명 이전 수준까지 낮춰야 합니다.
                      <br/>
                      <br/>
                      이제 우리는 단순한 환경 보호를 넘어, 지속 가능한 미래를 위한 근본적인 변화를 만들어야 합니다.
                      기후재단은 이러한 시대적 요구에 부응하여, 탄소 감축 및 탄소 크레딧 거래의 새로운 패러다임을 제시하고자 설립되었습니다.
                      <br/>
                      <br/>
                      ‘대기 중 온실가스 농도를 낮추자’ 이는 기후재단이 추구하는 명확한 방향성입니다. 현재의 자발적 탄소 크레딧 시장은 불명확한 MRV,
                      불투명한 인증 절차, 신뢰할 수 없는 감축 효과, 복잡한 거래 구조 등의 문제를 안고 있습니다.
                      <br/>
                      <br/>
                      기후재단은 이러한 문제를 해결하고, 보다 신뢰할 수 있는 자발적 탄소 크레딧 인증과 거래 시스템을 구축하기 위해 탄생했습니다.<br/>
                      우리는 탄소 감축 프로젝트의 과학적 인증 절차와 명확한 MRV 시스템을 통해 신뢰성을 확보하고, 쉽고 투명한 거래 환경을 조성하며,
                      미래를 위한 지속 가능한 탄소 감축 생태계를 구축하는 것을 목표로 합니다.<br/>
                      개인부터 단체, 법인, 더 나아가서는 국가까지 모두 카본 네거티브에 기여할 수 있는 발판을 마련할 것입니다.
                    </div>
                  </div>
                </section>

                <section className="fd_market" id="A2">
                  <div className="fd_market_title">
                    <h3 className="fd_con_title_h3">
                      <div class="min-titlef-blue"></div>기후재단이 만드는 새로운 탄소 크레딧 시장
                    </h3>
                  </div>

                  <div className="fd_market_process">
                    <div className="fd_market_process_first">
                      <div className="fd_first_head">
                        <div className="fd_first_head1">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="28" height="28" rx="6" fill="#59AF92"/>
                        <path d="M17.1185 6.95V21.62H13.8605V9.794H11.2685V6.95H17.1185Z" fill="white"/>
                        </svg>
                        <p className="fd_first_head_tit">까다로운 인증, 완벽한 신뢰성</p>
                        </div>
                        <div className="fd_first_head2">
                          현재 탄소 크레딧 시장에서는 프로젝트의 신뢰성을 입증하기 어려운 경우가 많아, 시장 형성을 방해 하고 있습니다. <br/>
                          실제 감축 효과가 없는 프로젝트를 통해 탄소 크레딧을 발행하거나, 허위 감축량을 보고하는 방식으로 시장이 왜곡되고 있습니다.
                          <br/>
                          <br/>
                          기후재단은 탄소 감축 프로젝트의 신뢰성 확보를 위한 인증 절차를 운영합니다. 
                        </div>

                        <div class="card-grid">
                          <div class="card">
                            <div class="card-icon">
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="40" height="40" rx="12" fill="#232652"/>
                              <path d="M15 17H9C7.9 17 7 16.1 7 15V9C7 7.9 7.9 7 9 7H15C16.1 7 17 7.9 17 9V15C17 16.1 16.1 17 15 17Z" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M15 33H9C7.9 33 7 32.1 7 31V25C7 23.9 7.9 23 9 23H15C16.1 23 17 23.9 17 25V31C17 32.1 16.1 33 15 33Z" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M21 9H33" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M21 13H28" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M21 25H33" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M21 29H28" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M10 11L12 13L15 10" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              <div class="card-title">다단계 심사 프로세스</div>
                            </div>
                            <div class="card-desc">
                              프로젝트 등록 후, 해당 프로젝트의 방법론과 예상 감축 효과를 분석하고, 이후 감축 성과를 검증합니다.
                            </div>
                          </div>

                          <div class="card">
                            <div class="card-icon">
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="40" height="40" rx="12" fill="#232652"/>
                              <g clip-path="url(#clip0_3020_31595)">
                              <path d="M27 6L28.593 9L32 9.414L29.5 11.667L30 15L27 13.125L24 15L24.5 11.667L22 9.414L25.5 9L27 6Z" fill="white"/>
                              <path d="M26.7164 17.2493L24.7789 16.7513C24.4316 18.0896 23.6954 19.295 22.6633 20.215C21.6313 21.1351 20.3497 21.7287 18.9805 21.9208C17.6113 22.1128 16.2159 21.8947 14.9705 21.2941C13.7252 20.6935 12.6858 19.7372 11.9837 18.5461C11.2816 17.355 10.9482 15.9826 11.0258 14.6021C11.1033 13.2217 11.5883 11.8952 12.4193 10.7902C13.2504 9.68523 14.3904 8.85138 15.6951 8.39398C16.9999 7.93658 18.411 7.87615 19.7501 8.22034L20.2491 6.28384C18.2974 5.77693 16.232 5.94085 14.3848 6.74926C12.5375 7.55768 11.0157 8.96364 10.0638 10.7412C9.11191 12.5188 8.78527 14.5648 9.13635 16.5504C9.48744 18.536 10.4959 20.3459 11.9996 21.6893V34.0003L17.9996 30.0003L23.9996 34.0003V21.7081C25.3276 20.5244 26.2734 18.9723 26.7164 17.2493ZM21.9996 30.263L17.9996 27.5965L13.9996 30.263V23.0503C15.2406 23.6738 16.61 23.9991 17.9988 24.0001C19.3877 24.0012 20.7576 23.6781 21.9996 23.0565V30.263Z" fill="white"/>
                              </g>
                              <defs>
                              <clipPath id="clip0_3020_31595">
                              <rect width="32" height="32" fill="white" transform="translate(4 4)"/>
                              </clipPath>
                              </defs>
                              </svg>
                              <div class="card-title">심의 기준</div>
                            </div>
                            <div class="card-desc">
                              기후재단의 인증 프로세스는 8가지 심의 기준을 토대로 더욱 강화된 자체 심사 기준을 적용합니다.
                            </div>
                          </div>

                          <div class="card">
                            <div class="card-icon">
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="40" height="40" rx="12" fill="#232652"/>
                              <path d="M24.788 28L28.252 34H25.944L22.48 28H17.532L14.068 34H11.76L15.224 28H9C8.73478 28 8.48043 27.8946 8.29289 27.7071C8.10536 27.5196 8 27.2652 8 27V10H6C5.73478 10 5.48043 9.89464 5.29289 9.70711C5.10536 9.51957 5 9.26522 5 9C5 8.73478 5.10536 8.48043 5.29289 8.29289C5.48043 8.10536 5.73478 8 6 8H34C34.2652 8 34.5196 8.10536 34.7071 8.29289C34.8946 8.48043 35 8.73478 35 9C35 9.26522 34.8946 9.51957 34.7071 9.70711C34.5196 9.89464 34.2652 10 34 10H32V27C32 27.2652 31.8946 27.5196 31.7071 27.7071C31.5196 27.8946 31.2652 28 31 28H24.788ZM30 10H10V26H30V10ZM15 18C15.2652 18 15.5196 18.1054 15.7071 18.2929C15.8946 18.4804 16 18.7348 16 19V21C16 21.2652 15.8946 21.5196 15.7071 21.7071C15.5196 21.8946 15.2652 22 15 22C14.7348 22 14.4804 21.8946 14.2929 21.7071C14.1054 21.5196 14 21.2652 14 21V19C14 18.7348 14.1054 18.4804 14.2929 18.2929C14.4804 18.1054 14.7348 18 15 18ZM20 16C20.2652 16 20.5196 16.1054 20.7071 16.2929C20.8946 16.4804 21 16.7348 21 17V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22C19.7348 22 19.4804 21.8946 19.2929 21.7071C19.1054 21.5196 19 21.2652 19 21V17C19 16.7348 19.1054 16.4804 19.2929 16.2929C19.4804 16.1054 19.7348 16 20 16ZM25 14C25.2652 14 25.5196 14.1054 25.7071 14.2929C25.8946 14.4804 26 14.7348 26 15V21C26 21.2652 25.8946 21.5196 25.7071 21.7071C25.5196 21.8946 25.2652 22 25 22C24.7348 22 24.4804 21.8946 24.2929 21.7071C24.1054 21.5196 24 21.2652 24 21V15C24 14.7348 24.1054 14.4804 24.2929 14.2929C24.4804 14.1054 24.7348 14 25 14Z" fill="white"/>
                              </svg>
                              <div class="card-title">데이터 기반 검증</div>
                            </div>
                            <div class="card-desc">
                              과거 감축 성과를 검토하고, 독립적인 제3자 기관의 검증을 통해 탄소 크레딧 발행의 신뢰성을 극대화합니다.
                            </div>
                          </div>

                          <div class="card">
                            <div class="card-icon">
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="40" height="40" rx="12" fill="#232652"/>
                              <g clip-path="url(#clip0_3020_31617)">
                              <path d="M33 30H27V26C27.0005 25.4697 27.2114 24.9613 27.5864 24.5864C27.9613 24.2114 28.4697 24.0005 29 24H31V22H27V20H31C31.5302 20.0006 32.0386 20.2115 32.4135 20.5865C32.7885 20.9614 32.9994 21.4698 33 22V24C32.9994 24.5302 32.7885 25.0386 32.4135 25.4135C32.0386 25.7885 31.5302 25.9994 31 26H29V28H33V30Z" fill="white"/>
                              <path d="M23 26H19C18.4698 25.9994 17.9614 25.7885 17.5865 25.4135C17.2115 25.0386 17.0006 24.5302 17 24V14C17.0005 13.4697 17.2114 12.9613 17.5864 12.5864C17.9613 12.2114 18.4697 12.0005 19 12H23C23.5303 12.0005 24.0387 12.2114 24.4136 12.5864C24.7886 12.9613 24.9995 13.4697 25 14V24C24.9994 24.5302 24.7885 25.0386 24.4135 25.4135C24.0386 25.7885 23.5302 25.9994 23 26ZM19 14V24H23V14H19Z" fill="white"/>
                              <path d="M15 26H9C8.46975 25.9994 7.9614 25.7885 7.58646 25.4135C7.21152 25.0386 7.00061 24.5302 7 24V14C7.00053 13.4697 7.21141 12.9613 7.58637 12.5864C7.96133 12.2114 8.46973 12.0005 9 12H15V14H9V24H15V26Z" fill="white"/>
                              </g>
                              <defs>
                              <clipPath id="clip0_3020_31617">
                              <rect width="32" height="32" fill="white" transform="translate(4 4)"/>
                              </clipPath>
                              </defs>
                              </svg>
                              <div class="card-title">고품질 탄소 크레딧 추구</div>
                            </div>
                            <div class="card-desc">
                              카본 네거티브를 실현할 수 있는 탄소 제거 기반 고품질 크레딧을 지향합니다.<br/>
                              모니터링 또한 추후준비되는 실측(측정) 방식을 적용하여, 명확한 MRV가 가능한 방법론을 추구합니다. 이를 통해 기관과 개인이 안심하고 탄소 감축 활동에 참여할 수 있도록 합니다.
                            </div>
                          </div>
                        </div>

                      </div>

                      <div className="fd_first_head fd_first_up">
                        <div className="fd_first_head1">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="28" height="28" rx="6" fill="#59AF92"/>
                        <path d="M14.7931 6.554C18.0871 6.554 20.0311 8.498 20.0311 11.162C20.0311 12.692 19.2931 14.006 16.7191 16.67L14.6131 18.848H20.3191V21.62H9.82507V19.748L14.6311 14.798C16.3951 12.98 16.8091 12.026 16.8091 11.198C16.8091 10.118 16.2151 9.398 14.7931 9.398C13.4611 9.398 12.7411 10.478 12.7411 11.594H9.51907C9.51907 8.714 11.6971 6.554 14.7931 6.554Z" fill="white"/>
                        </svg>
                        <p className="fd_first_head_tit">투명한 거래</p>
                        </div>
                        <div className="fd_first_head2">
                          자발적 탄소시장(VCM)은 감축량 중복 산정(Double Counting), 거래 기록의 불투명성 등의 문제로 시장 신뢰도가 낮습니다. 
                          기후재단은 위변조 방지 기술을 통해 탄소 크레딧의 추적성과 투명성을 보장합니다. 
                          이러한 기술적 접근 방식을 통해, 기후재단은 시장 불신을 해소하고 누구나 믿을 수 있는 거래 환경을 조성합니다.
                        </div>
                      </div>

                      <div className="fd_first_head fd_first_up">
                        <div className="fd_first_head1">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="28" height="28" rx="6" fill="#59AF92"/>
                        <path d="M14.8123 6.554C17.8543 6.554 19.9603 8.336 19.9603 10.964C19.9603 12.656 18.7183 13.898 17.4943 14.114C18.8443 14.33 20.3563 15.5 20.3563 17.39C20.3563 20.216 17.9623 21.98 14.9203 21.98C11.6983 21.98 9.70034 20.18 9.46634 17.354H12.6883C12.8143 18.524 13.5523 19.226 14.9203 19.226C16.2703 19.226 17.1703 18.488 17.1703 17.408C17.1703 16.184 16.1443 15.536 14.6143 15.536H13.1563V12.872H14.6143C15.9463 12.872 16.7383 12.152 16.7383 11.036C16.7383 9.956 16.0183 9.29 14.7943 9.29C13.5163 9.29 12.9223 10.316 12.9223 11.36H9.70034C9.70034 8.57 11.8063 6.554 14.8123 6.554Z" fill="white"/>
                        </svg>
                        <p className="fd_first_head_tit">누구나 쉽게 참여할 수 있는 플랫폼</p>
                        </div>
                        <div className="fd_first_head2">
                          탄소 크레딧 시장은 일반 소비자가 접근하기 어렵고, 기업조차도 거래 절차가 복잡하여 참여가 쉽지 않습니다. 
                          기후재단은 기업과 개인 모두가 손쉽게 탄소 감축 활동에 참여할 수 있도록, 직관적인 플랫폼을 제공합니다.
                        </div>

                        <div class="card-grid">
                          <div class="card">
                            <div class="card-icon">
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="40" height="40" rx="12" fill="#232652"/>
                              <path d="M7 15H33" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M11 13C10.7 13 10.5 12.9 10.3 12.7C10.1 12.5 10 12.3 10 12C10 11.7 10.1 11.5 10.3 11.3L10.4 11.2C10.5 11.2 10.5 11.1 10.6 11.1C10.7 11 10.7 11 10.8 11C10.9 11 11.1 11 11.2 11C11.3 11 11.3 11 11.4 11.1C11.5 11.1 11.5 11.2 11.6 11.2L11.7 11.3C11.8 11.4 11.9 11.5 11.9 11.6C12 11.7 12 11.9 12 12C12 12.1 12 12.3 11.9 12.4C11.9 12.5 11.8 12.6 11.7 12.7C11.5 12.9 11.3 13 11 13Z" fill="white"/>
                              <path d="M14 13.0001C13.7 13.0001 13.5 12.9001 13.3 12.7001C13.1 12.5001 13 12.3001 13 12.0001C13 11.9001 13 11.7001 13.1 11.6001C13.2 11.5001 13.2 11.4001 13.3 11.3001C13.4 11.2001 13.5 11.1001 13.6 11.1001C14 10.9001 14.4 11.0001 14.7 11.3001C14.8 11.4001 14.9 11.5001 14.9 11.6001C15 11.7001 15 11.9001 15 12.0001C15 12.3001 14.9 12.5001 14.7 12.7001C14.5 12.9001 14.3 13.0001 14 13.0001Z" fill="white"/>
                              <path d="M17 13C16.9 13 16.7 13 16.6 12.9C16.5 12.8 16.4 12.8 16.3 12.7C16.2 12.6 16.1 12.5 16.1 12.4C16 12.3 16 12.1 16 12C16 11.9 16 11.7 16.1 11.6C16.2 11.5 16.2 11.4 16.3 11.3C16.7 10.9 17.3 10.9 17.7 11.3C17.8 11.4 17.9 11.5 17.9 11.6C18 11.7 18 11.9 18 12C18 12.1 18 12.3 17.9 12.4C17.8 12.5 17.8 12.6 17.7 12.7C17.5 12.9 17.3 13 17 13Z" fill="white"/>
                              <path d="M31 9H9C7.9 9 7 9.9 7 11V29C7 30.1 7.9 31 9 31H31C32.1 31 33 30.1 33 29V11C33 9.9 32.1 9 31 9Z" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M20 28C22.7614 28 25 25.7614 25 23C25 20.2386 22.7614 18 20 18C17.2386 18 15 20.2386 15 23C15 25.7614 17.2386 28 20 28Z" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M20 28C21.1046 28 22 25.7614 22 23C22 20.2386 21.1046 18 20 18C18.8954 18 18 20.2386 18 23C18 25.7614 18.8954 28 20 28Z" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              <div class="card-title">사용자 친화적인 인터페이스</div>
                            </div>
                            <div class="card-desc">
                              복잡한 절차 없이, 몇 번의 클릭만으로 탄소 크레딧을 구매하거나 거래할 수 있도록 설계합니다. 
                            </div>
                          </div>

                          <div class="card">
                            <div class="card-icon">
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="40" height="40" rx="12" fill="#232652"/>
                              <g clip-path="url(#clip0_3020_31720)">
                              <path d="M29.7983 13.9999C29.3349 11.7311 28.0985 9.69348 26.3002 8.23473C24.5018 6.77597 22.2529 5.98654 19.9373 6.00118C17.6218 6.01581 15.383 6.8336 13.6032 8.31497C11.8234 9.79634 10.6129 11.8495 10.1783 14.1239C8.33353 14.4534 6.6791 15.4619 5.54098 16.9506C4.40286 18.4394 3.86359 20.3004 4.02943 22.167C4.19527 24.0335 5.0542 25.7703 6.43696 27.0351C7.81972 28.2998 9.62604 29.0008 11.5 28.9999H12V26.9999H11.5C10.0743 27.0009 8.70414 26.4478 7.6786 25.4575C6.65306 24.4672 6.05243 23.1172 6.00351 21.6924C5.95458 20.2677 6.4612 18.8796 7.4164 17.8213C8.3716 16.763 9.70064 16.1173 11.123 16.0204L11.9595 15.9633L12.0495 15.1298C12.2518 13.2693 13.1004 11.5387 14.4476 10.2397C15.7948 8.94066 17.5551 8.15551 19.4218 8.02106C21.2884 7.88661 23.1431 8.4114 24.6626 9.50396C26.182 10.5965 27.2699 12.1876 27.7368 13.9999H29.7983Z" fill="white"/>
                              <path d="M32 16H22C21.4698 16.0006 20.9614 16.2115 20.5865 16.5865C20.2115 16.9614 20.0006 17.4698 20 18V22H16C15.4698 22.0006 14.9614 22.2115 14.5865 22.5865C14.2115 22.9614 14.0006 23.4698 14 24V34H34V18C33.9994 17.4698 33.7885 16.9614 33.4135 16.5865C33.0386 16.2115 32.5302 16.0006 32 16ZM16 32V24H20V32H16ZM32 32H22V18H32V32Z" fill="white"/>
                              <path d="M26 20H24V24H26V20Z" fill="white"/>
                              <path d="M30 20H28V24H30V20Z" fill="white"/>
                              <path d="M26 26H24V30H26V26Z" fill="white"/>
                              <path d="M30 26H28V30H30V26Z" fill="white"/>
                              </g>
                              <defs>
                              <clipPath id="clip0_3020_31720">
                              <rect width="32" height="32" fill="white" transform="translate(4 4)"/>
                              </clipPath>
                              </defs>
                              </svg>

                              <div class="card-title">기업 맞춤형 솔루션 제공</div>
                            </div>
                            <div class="card-desc">
                              기업이 자체적인 탄소중립 목표를 설정하고, 이를 달성할 수 있도록 맞춤형 감축전략을 제공합니다.
                            </div>
                          </div>

                          <div class="card">
                            <div class="card-icon">
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="40" height="40" rx="12" fill="#232652"/>
                              <path d="M28.0004 13.547C27.9204 13.5337 27.8271 13.5337 27.7471 13.547C25.9071 13.4803 24.4404 11.9737 24.4404 10.107C24.4404 8.20033 25.9738 6.66699 27.8804 6.66699C29.7871 6.66699 31.3204 8.21366 31.3204 10.107C31.3071 11.9737 29.8404 13.4803 28.0004 13.547Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M26.6269 23.2538C28.4536 23.5605 30.4669 23.2405 31.8802 22.2938C33.7602 21.0405 33.7602 18.9872 31.8802 17.7338C30.4536 16.7872 28.4136 16.4672 26.5869 16.7872" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M11.9596 13.547C12.0396 13.5337 12.133 13.5337 12.213 13.547C14.053 13.4803 15.5196 11.9737 15.5196 10.107C15.5196 8.20033 13.9863 6.66699 12.0796 6.66699C10.173 6.66699 8.63965 8.21366 8.63965 10.107C8.65298 11.9737 10.1196 13.4803 11.9596 13.547Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M13.3333 23.2538C11.5066 23.5605 9.49325 23.2405 8.07992 22.2938C6.19992 21.0405 6.19992 18.9872 8.07992 17.7338C9.50659 16.7872 11.5466 16.4672 13.3733 16.7872" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M20.0005 23.507C19.9205 23.4937 19.8272 23.4937 19.7472 23.507C17.9072 23.4403 16.4404 21.9337 16.4404 20.067C16.4404 18.1603 17.9738 16.627 19.8805 16.627C21.7871 16.627 23.3205 18.1737 23.3205 20.067C23.3071 21.9337 21.8405 23.4537 20.0005 23.507Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M16.12 27.7065C14.24 28.9598 14.24 31.0132 16.12 32.2665C18.2533 33.6932 21.7467 33.6932 23.88 32.2665C25.76 31.0132 25.76 28.9598 23.88 27.7065C21.76 26.2932 18.2533 26.2932 16.12 27.7065Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              <div class="card-title">개인도 쉽게 탄소 감축에 기여</div>
                            </div>
                            <div class="card-desc">
                              기업뿐만 아니라 개인도 탄소 크레딧을 구매하여 자신의 탄소 발자국을 줄일 수 있도록 지원합니다.
                            </div>
                          </div>
                        </div>

                      </div>

                    </div>
                  </div>
                </section>

                <section className="fd_market" id="A3">
                  <div className="fd_con_title">
                    <h3 className="fd_con_title_h3">
                      <div class="min-titlef-blue"></div>이사장 인사말
                    </h3>
                  </div>
                  <p className="fd_con_title_subtit">탄소 네거티브 시대의 선구자, 지속 가능한 미래를 위한 약속</p>

                  <div className="fd_con_bgpanel">
                    <div className="fd_con_pn_desc" style={{textAlign:"left"}}>
                      안녕하십니까.
                      기후재단을 방문해 주신 여러분께 감사의 인사를 드립니다.
                      <br/>
                      <br/>
                      오늘날 인류는 탄소중립(Net-Zero) 이라는 중대한 과제에 직면해 있습니다. <br/>
                      하지만 탄소 감축 노력만으론 기후 위기 가속화를 막을수 없습니다. 진정한 탄소중립과 미래 세대의 안전을 위해서 우리는 대기 중의 탄소를 제거하는 
                      탄소 네거티브 배출(CDR, Carbon Dioxide Removal)의 역할에 주목해야 합니다.
                      <br/>
                      <br/>
                      기후재단은 자발적 탄소시장(VCM) 에서 CDR분야의 신뢰 구축과 활성화 그리고 더 나아가서는 기후 변화 대응에 대한 사회적 책임을 다하기 위해 설립되었습니다.<br/>
                      탄소감축과 탄소제거 노력이 함께 병행되어야 인류가 배출한 이산화탄소 농도를 실질적으로 저감할 수 있으며, 이로써 지구의 탄소 잔고를 실질적으로 줄이는 것에 
                      이바지하고자 합니다.
                      <br/>
                      <br/>
                      <p>우리의 핵심 비전은 다음과 같습니다.</p>
                      <p>
                        <ul style={{listStyle:"disc"}}>
                          <li>국제 표준에 부합하는 방법론 심사 및 인증 표준 수립</li>
                          <li>최고의 무결성(Integrity)을 갖춘 CDR 표준 제정</li>
                          <li>자발적 탄소시장 탄소크레딧 프로그램 운영</li>
                          <li>혁신적인 CDR 기술 장려</li>
                          <li>VCM 시장 규범 정립</li>
                          <li>투명성 확보와 사회적 책임</li>
                        </ul>
                      </p>
                      우리는 정부, 산업계, 학계 그리고 시민사회와 긴밀하게 협력하며, 탄소 네거티브 사회로의 전환을 가속화하는 신뢰의 엔진이 되겠습니다. <br/>
                      기후재단의 여정에 따뜻한 관심과 성원을 부탁드립니다.<br/>
                      감사합니다.<br/>
                      <br/>
                      <p style={{textAlign:"center"}}>기후재단 이사장 이철 드림</p>
                    </div>
                  </div>
                </section>

                <section className="fd_market" id="A4">
                  <div className="fd_con_title">
                    <h3 className="fd_con_title_h3">
                      <div class="min-titlef-blue"></div>연혁
                    </h3>
                  </div>

                  <div className="fd_con_bgpanel">
                    <div class="vc_column_container">
                      <div class="vc_column-inner ">
                        <div class="wpb_wrapper">

                          <div class="history-content last-paragraph-no-margin">
                            <ul>
                              <p class="year">2025</p>
                              <li class="content">
                                <ul>
                                  <li>
                                    <strong>2025. 12</strong>
                                    <p>기획재정부 공익법인 지정<br/></p>
                                  </li>
                                  <li>
                                    <strong>2025. 9</strong>
                                    <p>환경부 비영리법인 설립허가 (재단법인 기후재단)<br/></p>
                                  </li>
                                  <li>
                                    <strong>2025. 3</strong>
                                    <p>탄소 상쇄 크레딧 플랫폼 런칭 설명회 개최<br/></p>
                                  </li>
                                  <li>
                                    <strong>2025. 2</strong>
                                    <p>재단설립위원회 구성<br/></p>
                                  </li>
                                </ul>
                              </li>
                              
                            </ul>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="fd_market" id="A5">
                  <div className="fd_con_title">
                    <h3 className="fd_con_title_h3">
                      <div class="min-titlef-blue"></div>조직도
                    </h3>
                  </div>

                  <div className="fd_con_bgpanel">
                    <div class="organization" style={{textAlign:"center"}}>
                      <img src="/assets/img/organization.png"></img>
                    </div>
                    <br/>
                    <div class="organization_list">
                      <div class="list_1st" style={{paddingLeft:"30px"}}>
                        <dl>
                          <dt>- 이사회</dt>
                          <dd style={{fontSize: "16px"}}>정관에 따라 이사장, 상임이사, 이사 등 5명으로 구성한다.</dd>
                        </dl>
                      </div>

                      <div className="table-container">
                        <table className="custom-table">
                          <thead>
                            <tr style={{textAlign:"center"}}>
                              <th>부서</th>
                              <th>이름/직책</th>
                              <th>소속</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td rowSpan="11" style={{textAlign:"center"}}>이사회</td>
                              <td>이철 이사장</td>
                              <td>기후재단 이사장</td>
                            </tr>
                            <tr>
                              <td>강신걸 이사(상임)</td>
                              <td>기후재단</td>
                            </tr>
                            <tr>
                              <td>최한상 이사</td>
                              <td>기후재단</td>
                            </tr>
                            <tr>
                              <td>정영민 이사</td>
                              <td>기후재단</td>
                            </tr>
                            <tr>
                              <td>김종식 이사</td>
                              <td>기후재단</td>
                            </tr>
                            <tr>
                              <td>백승덕 감사</td>
                              <td>기후재단</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <br/>
                    <div class="organization_list">
                      <div class="list_1st" style={{paddingLeft:"30px"}}>
                        <dl>
                          <dt>- 운영위원회</dt>
                          <dd style={{fontSize: "16px"}}>기후재단의 지속적인 발전과 운영을 위해 전문 지식과 경험을 갖춘 전문가들로 운영위원회를 운영합니다. 운영위원회는 탄소 크레딧을 확보하고 자발적 탄소시장 활성화 방안을 개발하고 지원하며, 탄소감축 인증 기준을 심의하고 조정합니다.</dd>
                        </dl>
                      </div>

                      <div className="table-container">
                        <table className="custom-table">
                          <thead>
                            <tr style={{textAlign:"center"}}>
                              <th>부서</th>
                              <th>이름/직책</th>
                              <th>소속</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td rowSpan="11" style={{textAlign:"center"}}>운영위원회</td>
                              <td>김영춘 운영위원장</td>
                              <td>(전) 해양수산부 장관</td>
                            </tr>
                            <tr>
                              <td>도종광 운영위원</td>
                              <td>VCM 활성화 담당, ㈜한국인프라개발 대표이사</td>
                            </tr>
                            <tr>
                              <td>김창호 운영위원</td>
                              <td>파트너쉽 개발 담당, 한국자치경영협의회 대표이사</td>
                            </tr>
                            <tr>
                              <td>황의정 운영위원</td>
                              <td>대표 변호사, 법무법인 KJ 법률사무소</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <br/>
                    <div class="organization_list">
                      <div class="list_1st" style={{paddingLeft:"30px"}}>
                        <dl>
                          <dt>- 인증위원회</dt>
                          <dd style={{fontSize: "16px"}}>기후재단 프로그램을 통한 탄소감축 활동을 인증하기 위해 독립적인 인증위원회를 설치하고 운영합니다. 재단은 방법론 및 프로젝트 등록에 대한 최종 결정과 KCR 발급 자격에 대한 책임을 인증위원회에 위임함으로써 KCR(상쇄 크레딧)에 대한 높은 신뢰성을 확보합니다</dd>
                        </dl>
                      </div>

                      <div className="table-container">
                        <table className="custom-table">
                          <thead>
                            <tr style={{textAlign:"center"}}>
                              <th>부서</th>
                              <th>이름/직책</th>
                              <th>소속</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td rowSpan="11" style={{textAlign:"center"}}>인증위원회</td>
                              <td>이종수 인증위원장</td>
                              <td>교수, 서울대학교 연구처장</td>
                            </tr>
                            <tr>
                              <td>이민호 인증위원</td>
                              <td>법무법인 율촌 ESG연구소장</td>
                            </tr>
                            <tr>
                              <td>정철오 인증위원</td>
                              <td>변리사, 특허법인 누리 대표</td>
                            </tr>
                            <tr>
                              <td>이민아 인증위원</td>
                              <td>박사, ㈜뉴톤 부사장</td>
                            </tr>
                            <tr>
                              <td>위영호 인증위원</td>
                              <td>박사, ㈜로우카본 카본프리연구소장</td>
                            </tr>
                            <tr>
                              <td>황유현 인증위원</td>
                              <td>변호사, 법무법인 인헌</td>
                            </tr>
                            <tr>
                              <td>전기원 박사</td>
                              <td>한국 화학 연구원</td>
                            </tr>
                            <tr>
                              <td>김우현 박사</td>
                              <td>(전)기계 연구원</td>
                            </tr>
                            <tr>
                              <td>이미화 대표</td>
                              <td>환경일보</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <br/>
                    <div class="organization_list">
                      <div class="list_1st" style={{paddingLeft:"30px"}}>
                        <dl>
                          <dt>- 사무국</dt>
                          <dd style={{fontSize: "16px"}}>기후 변화와 지속가능한 개발에 대응하려면 기술적 리더십, 다양성, 그리고 글로벌 마인드가 필요합니다. 사무국은 전 세계에 배치된 전문가들로 확대해 나갈 것입니다. 고객에게는 크레딧을, 언제든지 연락해 주시기 바랍니다.</dd>
                        </dl>
                      </div>

                      <div className="table-container">
                        <table className="custom-table">
                          <thead>
                            <tr style={{textAlign:"center"}}>
                              <th>부서</th>
                              <th>이름/직책</th>
                              <th>업무</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style={{textAlign:"center"}}>사무국</td>
                              <td>김홍일 사무국장</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td style={{textAlign:"center"}}>인증그룹</td>
                              <td>이지웅</td>
                              <td>- 방법론 개발 및 인증<br/>
                                  - 표준 개발 및 혁신</td>
                            </tr>
                            <tr>
                              <td style={{textAlign:"center"}}>컨설팅그룹</td>
                              <td>박은지</td>
                              <td>- 탄소저감, 탄소제거 사업 컨설팅<br/>
                                  - ESG 경영 컨설팅</td>
                            </tr>
                            <tr>
                              <td style={{textAlign:"center"}}>운영그룹</td>
                              <td>김홍일</td>
                              <td>마케팅 및 커뮤니케이션</td>
                            </tr>
                            <tr>
                              <td style={{textAlign:"center"}}>운영그룹</td>
                              <td>이중학</td>
                              <td>시장 개발, 대외 업무</td>
                            </tr>
                            <tr>
                              <td style={{textAlign:"center"}}>운영그룹</td>
                              <td>이영묵</td>
                              <td>운영 및 기술지원</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div style={{paddingLeft: "30px"}}>
                      <div style={{fontWeight: "600"}}>- 외부 협력기관</div>
                      <div>
                        <ul style={{listStyle:"disc", fontSize: "15px", padding: "20px 0 0 20px"}}>
                          <li>Global CCUS학회</li>
                          <li>KCCUS연구원</li>
                          <li>한국 ESG 학회</li>
                        </ul>
                      </div>
                    </div>

                  </div>
                </section>

              </div>
           )}
           {props.language == "en" && (
              <div className="page-content">
                <section id="A1">
                  <div className="fd_con_title">
                    <h3 className="fd_con_title_h3">
                      <div class="min-titlef-blue"></div>Purpose and vision of the foundation
                    </h3>
                  </div>
                  <p className="fd_con_title_subtit">Responding to climate change is no longer an option but a necessity</p>

                  <div className="fd_con_bgpanel">
                    <div className="fd_con_pn_desc">
                      The climate crisis is the most severe task humanity faces.<br />
                      It is time to actively recognize and practice that the climate triggers disasters from a spectator's perspective on climate change.<br/>
                      Humanity's declaration of net zero only delays the arrival period of the climate apocalypse and is not solely the fundamental method to resolve the issues.<br/>
                     Beyond net zero, we must reduce greenhouse gas concentrations in the atmosphere to pre-industrial levels through active carbon negativity.
                      <br/>
                      <br/>
                      From now on, we must transcend simple environmental protection to make fundamental changes for a sustainable future. The Climate Foundation was established to meet this demand and to present a new paradigm for carbon reduction and carbon credit trading.
                      <br/>
                      <br/>
                      'Reducing atmospheric greenhouse gas concentrations' is the clear vision pursued by the Climate Foundation. The current voluntary carbon credit market coexists with the issues of unclear MRV, opaque certification processes, unreliable reduction outcomes, and complex transaction structures.
                      <br/>
                      <br/>
                      The Climate Foundation was established to address these issues and build a more reliable voluntary carbon credit certification and trading system.
                      We aim to secure credibility through scientific certification procedures and a clear MRV system for carbon reduction projects, create an easy and transparent trading environment, and build a sustainable carbon reduction ecosystem for the future to establish the foundation baseline for individuals, organizations, corporations, and nations for the contribution to carbon negativity.
                    </div>
                  </div>
                </section>

                <section className="fd_market" id="A2">
                  <div className="fd_market_title">
                    <h3 className="fd_con_title_h3">
                      <div class="min-titlef-blue"></div>A new carbon credit market created by the Climate Foundation
                    </h3>
                  </div>

                  <div className="fd_market_process">
                    <div className="fd_market_process_first">
                      <div className="fd_first_head">
                        <div className="fd_first_head1">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="28" height="28" rx="6" fill="#59AF92"/>
                        <path d="M17.1185 6.95V21.62H13.8605V9.794H11.2685V6.95H17.1185Z" fill="white"/>
                        </svg>
                        <p className="fd_first_head_tit">Strict certification, perfect reliability</p>
                        </div>
                        <div className="fd_first_head2">
                          The current carbon credit market is frequently challenged in proving the project's reliability, which hinders market formation. <br/>
                          The market is distorted by the reporting of false reduction amounts or the issue of carbon credits that are not creditable.
                          <br/>
                          <br/>
                          The Climate Foundation operates a certification procedure to ensure the reliability of carbon reduction projects.
                        </div>

                        <div class="card-grid">
                          <div class="card">
                            <div class="card-icon">
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="40" height="40" rx="12" fill="#232652"/>
                              <path d="M15 17H9C7.9 17 7 16.1 7 15V9C7 7.9 7.9 7 9 7H15C16.1 7 17 7.9 17 9V15C17 16.1 16.1 17 15 17Z" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M15 33H9C7.9 33 7 32.1 7 31V25C7 23.9 7.9 23 9 23H15C16.1 23 17 23.9 17 25V31C17 32.1 16.1 33 15 33Z" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M21 9H33" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M21 13H28" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M21 25H33" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M21 29H28" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M10 11L12 13L15 10" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              <div class="card-title">Phase-by-phase review of the process</div>
                            </div>
                            <div class="card-desc">
                              Following project registration, examine the methodology and anticipated reduction effects, then verify the reduction performance afterwards.
                            </div>
                          </div>

                          <div class="card">
                            <div class="card-icon">
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="40" height="40" rx="12" fill="#232652"/>
                              <g clip-path="url(#clip0_3020_31595)">
                              <path d="M27 6L28.593 9L32 9.414L29.5 11.667L30 15L27 13.125L24 15L24.5 11.667L22 9.414L25.5 9L27 6Z" fill="white"/>
                              <path d="M26.7164 17.2493L24.7789 16.7513C24.4316 18.0896 23.6954 19.295 22.6633 20.215C21.6313 21.1351 20.3497 21.7287 18.9805 21.9208C17.6113 22.1128 16.2159 21.8947 14.9705 21.2941C13.7252 20.6935 12.6858 19.7372 11.9837 18.5461C11.2816 17.355 10.9482 15.9826 11.0258 14.6021C11.1033 13.2217 11.5883 11.8952 12.4193 10.7902C13.2504 9.68523 14.3904 8.85138 15.6951 8.39398C16.9999 7.93658 18.411 7.87615 19.7501 8.22034L20.2491 6.28384C18.2974 5.77693 16.232 5.94085 14.3848 6.74926C12.5375 7.55768 11.0157 8.96364 10.0638 10.7412C9.11191 12.5188 8.78527 14.5648 9.13635 16.5504C9.48744 18.536 10.4959 20.3459 11.9996 21.6893V34.0003L17.9996 30.0003L23.9996 34.0003V21.7081C25.3276 20.5244 26.2734 18.9723 26.7164 17.2493ZM21.9996 30.263L17.9996 27.5965L13.9996 30.263V23.0503C15.2406 23.6738 16.61 23.9991 17.9988 24.0001C19.3877 24.0012 20.7576 23.6781 21.9996 23.0565V30.263Z" fill="white"/>
                              </g>
                              <defs>
                              <clipPath id="clip0_3020_31595">
                              <rect width="32" height="32" fill="white" transform="translate(4 4)"/>
                              </clipPath>
                              </defs>
                              </svg>
                              <div class="card-title">Review Criteria</div>
                            </div>
                            <div class="card-desc">
                              The Climate Foundation’s certification process applies our own review criteria that have been strengthened based on eight review criteria.
                            </div>
                          </div>

                          <div class="card">
                            <div class="card-icon">
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="40" height="40" rx="12" fill="#232652"/>
                              <path d="M24.788 28L28.252 34H25.944L22.48 28H17.532L14.068 34H11.76L15.224 28H9C8.73478 28 8.48043 27.8946 8.29289 27.7071C8.10536 27.5196 8 27.2652 8 27V10H6C5.73478 10 5.48043 9.89464 5.29289 9.70711C5.10536 9.51957 5 9.26522 5 9C5 8.73478 5.10536 8.48043 5.29289 8.29289C5.48043 8.10536 5.73478 8 6 8H34C34.2652 8 34.5196 8.10536 34.7071 8.29289C34.8946 8.48043 35 8.73478 35 9C35 9.26522 34.8946 9.51957 34.7071 9.70711C34.5196 9.89464 34.2652 10 34 10H32V27C32 27.2652 31.8946 27.5196 31.7071 27.7071C31.5196 27.8946 31.2652 28 31 28H24.788ZM30 10H10V26H30V10ZM15 18C15.2652 18 15.5196 18.1054 15.7071 18.2929C15.8946 18.4804 16 18.7348 16 19V21C16 21.2652 15.8946 21.5196 15.7071 21.7071C15.5196 21.8946 15.2652 22 15 22C14.7348 22 14.4804 21.8946 14.2929 21.7071C14.1054 21.5196 14 21.2652 14 21V19C14 18.7348 14.1054 18.4804 14.2929 18.2929C14.4804 18.1054 14.7348 18 15 18ZM20 16C20.2652 16 20.5196 16.1054 20.7071 16.2929C20.8946 16.4804 21 16.7348 21 17V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22C19.7348 22 19.4804 21.8946 19.2929 21.7071C19.1054 21.5196 19 21.2652 19 21V17C19 16.7348 19.1054 16.4804 19.2929 16.2929C19.4804 16.1054 19.7348 16 20 16ZM25 14C25.2652 14 25.5196 14.1054 25.7071 14.2929C25.8946 14.4804 26 14.7348 26 15V21C26 21.2652 25.8946 21.5196 25.7071 21.7071C25.5196 21.8946 25.2652 22 25 22C24.7348 22 24.4804 21.8946 24.2929 21.7071C24.1054 21.5196 24 21.2652 24 21V15C24 14.7348 24.1054 14.4804 24.2929 14.2929C24.4804 14.1054 24.7348 14 25 14Z" fill="white"/>
                              </svg>
                              <div class="card-title">Data-based verification</div>
                            </div>
                            <div class="card-desc">
                              We review past reduction performance and maximize the reliability of carbon credit issuance through verification by an independent third-party organization.
                            </div>
                          </div>

                          <div class="card">
                            <div class="card-icon">
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="40" height="40" rx="12" fill="#232652"/>
                              <g clip-path="url(#clip0_3020_31617)">
                              <path d="M33 30H27V26C27.0005 25.4697 27.2114 24.9613 27.5864 24.5864C27.9613 24.2114 28.4697 24.0005 29 24H31V22H27V20H31C31.5302 20.0006 32.0386 20.2115 32.4135 20.5865C32.7885 20.9614 32.9994 21.4698 33 22V24C32.9994 24.5302 32.7885 25.0386 32.4135 25.4135C32.0386 25.7885 31.5302 25.9994 31 26H29V28H33V30Z" fill="white"/>
                              <path d="M23 26H19C18.4698 25.9994 17.9614 25.7885 17.5865 25.4135C17.2115 25.0386 17.0006 24.5302 17 24V14C17.0005 13.4697 17.2114 12.9613 17.5864 12.5864C17.9613 12.2114 18.4697 12.0005 19 12H23C23.5303 12.0005 24.0387 12.2114 24.4136 12.5864C24.7886 12.9613 24.9995 13.4697 25 14V24C24.9994 24.5302 24.7885 25.0386 24.4135 25.4135C24.0386 25.7885 23.5302 25.9994 23 26ZM19 14V24H23V14H19Z" fill="white"/>
                              <path d="M15 26H9C8.46975 25.9994 7.9614 25.7885 7.58646 25.4135C7.21152 25.0386 7.00061 24.5302 7 24V14C7.00053 13.4697 7.21141 12.9613 7.58637 12.5864C7.96133 12.2114 8.46973 12.0005 9 12H15V14H9V24H15V26Z" fill="white"/>
                              </g>
                              <defs>
                              <clipPath id="clip0_3020_31617">
                              <rect width="32" height="32" fill="white" transform="translate(4 4)"/>
                              </clipPath>
                              </defs>
                              </svg>
                              <div class="card-title">High-quality carbon credits</div>
                            </div>
                            <div class="card-desc">
                              Our continuous endeavor aims for high-quality carbon credits based on carbon removal that can implement carbon negativity.<br/>
                              In monitoring terms, we pursue a clear MRV method by applying a measurement rather than an estimation.
                            </div>
                          </div>
                        </div>

                      </div>

                      <div className="fd_first_head fd_first_up">
                        <div className="fd_first_head1">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="28" height="28" rx="6" fill="#59AF92"/>
                        <path d="M14.7931 6.554C18.0871 6.554 20.0311 8.498 20.0311 11.162C20.0311 12.692 19.2931 14.006 16.7191 16.67L14.6131 18.848H20.3191V21.62H9.82507V19.748L14.6311 14.798C16.3951 12.98 16.8091 12.026 16.8091 11.198C16.8091 10.118 16.2151 9.398 14.7931 9.398C13.4611 9.398 12.7411 10.478 12.7411 11.594H9.51907C9.51907 8.714 11.6971 6.554 14.7931 6.554Z" fill="white"/>
                        </svg>
                        <p className="fd_first_head_tit">Transparent Transactions</p>
                        </div>
                        <div className="fd_first_head2">
                          The reliability of the VCM (Voluntary Carbon Market) is under suspicion due to double counting of reduction amounts and lack of transparency in transaction records. The anti-counterfeiting technology ensures the traceability and reliability of carbon credits.
                          This technological approach fosters a trustworthy trading environment for everyone and eradicates mistrust of the carbon credit market.
                        </div>
                      </div>

                      <div className="fd_first_head fd_first_up">
                        <div className="fd_first_head1">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="28" height="28" rx="6" fill="#59AF92"/>
                        <path d="M14.8123 6.554C17.8543 6.554 19.9603 8.336 19.9603 10.964C19.9603 12.656 18.7183 13.898 17.4943 14.114C18.8443 14.33 20.3563 15.5 20.3563 17.39C20.3563 20.216 17.9623 21.98 14.9203 21.98C11.6983 21.98 9.70034 20.18 9.46634 17.354H12.6883C12.8143 18.524 13.5523 19.226 14.9203 19.226C16.2703 19.226 17.1703 18.488 17.1703 17.408C17.1703 16.184 16.1443 15.536 14.6143 15.536H13.1563V12.872H14.6143C15.9463 12.872 16.7383 12.152 16.7383 11.036C16.7383 9.956 16.0183 9.29 14.7943 9.29C13.5163 9.29 12.9223 10.316 12.9223 11.36H9.70034C9.70034 8.57 11.8063 6.554 14.8123 6.554Z" fill="white"/>
                        </svg>
                        <p className="fd_first_head_tit">Easily accessible platform to the public</p>
                        </div>
                        <div className="fd_first_head2">
                          The carbon credit market is currently at a stage where it is difficult for the consuming public and even companies to access due to the complicated transaction process, which makes it difficult to participate.
                          The Climate Foundation provides an intuitive platform to ease the participation of both companies and individuals in carbon reduction activities.
                        </div>

                        <div class="card-grid">
                          <div class="card">
                            <div class="card-icon">
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="40" height="40" rx="12" fill="#232652"/>
                              <path d="M7 15H33" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M11 13C10.7 13 10.5 12.9 10.3 12.7C10.1 12.5 10 12.3 10 12C10 11.7 10.1 11.5 10.3 11.3L10.4 11.2C10.5 11.2 10.5 11.1 10.6 11.1C10.7 11 10.7 11 10.8 11C10.9 11 11.1 11 11.2 11C11.3 11 11.3 11 11.4 11.1C11.5 11.1 11.5 11.2 11.6 11.2L11.7 11.3C11.8 11.4 11.9 11.5 11.9 11.6C12 11.7 12 11.9 12 12C12 12.1 12 12.3 11.9 12.4C11.9 12.5 11.8 12.6 11.7 12.7C11.5 12.9 11.3 13 11 13Z" fill="white"/>
                              <path d="M14 13.0001C13.7 13.0001 13.5 12.9001 13.3 12.7001C13.1 12.5001 13 12.3001 13 12.0001C13 11.9001 13 11.7001 13.1 11.6001C13.2 11.5001 13.2 11.4001 13.3 11.3001C13.4 11.2001 13.5 11.1001 13.6 11.1001C14 10.9001 14.4 11.0001 14.7 11.3001C14.8 11.4001 14.9 11.5001 14.9 11.6001C15 11.7001 15 11.9001 15 12.0001C15 12.3001 14.9 12.5001 14.7 12.7001C14.5 12.9001 14.3 13.0001 14 13.0001Z" fill="white"/>
                              <path d="M17 13C16.9 13 16.7 13 16.6 12.9C16.5 12.8 16.4 12.8 16.3 12.7C16.2 12.6 16.1 12.5 16.1 12.4C16 12.3 16 12.1 16 12C16 11.9 16 11.7 16.1 11.6C16.2 11.5 16.2 11.4 16.3 11.3C16.7 10.9 17.3 10.9 17.7 11.3C17.8 11.4 17.9 11.5 17.9 11.6C18 11.7 18 11.9 18 12C18 12.1 18 12.3 17.9 12.4C17.8 12.5 17.8 12.6 17.7 12.7C17.5 12.9 17.3 13 17 13Z" fill="white"/>
                              <path d="M31 9H9C7.9 9 7 9.9 7 11V29C7 30.1 7.9 31 9 31H31C32.1 31 33 30.1 33 29V11C33 9.9 32.1 9 31 9Z" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M20 28C22.7614 28 25 25.7614 25 23C25 20.2386 22.7614 18 20 18C17.2386 18 15 20.2386 15 23C15 25.7614 17.2386 28 20 28Z" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M20 28C21.1046 28 22 25.7614 22 23C22 20.2386 21.1046 18 20 18C18.8954 18 18 20.2386 18 23C18 25.7614 18.8954 28 20 28Z" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              <div class="card-title">User-friendly interface</div>
                            </div>
                            <div class="card-desc">
                              Designed to take only a few clicks for the carbon credit transaction, with no complication. 
                            </div>
                          </div>

                          <div class="card">
                            <div class="card-icon">
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="40" height="40" rx="12" fill="#232652"/>
                              <g clip-path="url(#clip0_3020_31720)">
                              <path d="M29.7983 13.9999C29.3349 11.7311 28.0985 9.69348 26.3002 8.23473C24.5018 6.77597 22.2529 5.98654 19.9373 6.00118C17.6218 6.01581 15.383 6.8336 13.6032 8.31497C11.8234 9.79634 10.6129 11.8495 10.1783 14.1239C8.33353 14.4534 6.6791 15.4619 5.54098 16.9506C4.40286 18.4394 3.86359 20.3004 4.02943 22.167C4.19527 24.0335 5.0542 25.7703 6.43696 27.0351C7.81972 28.2998 9.62604 29.0008 11.5 28.9999H12V26.9999H11.5C10.0743 27.0009 8.70414 26.4478 7.6786 25.4575C6.65306 24.4672 6.05243 23.1172 6.00351 21.6924C5.95458 20.2677 6.4612 18.8796 7.4164 17.8213C8.3716 16.763 9.70064 16.1173 11.123 16.0204L11.9595 15.9633L12.0495 15.1298C12.2518 13.2693 13.1004 11.5387 14.4476 10.2397C15.7948 8.94066 17.5551 8.15551 19.4218 8.02106C21.2884 7.88661 23.1431 8.4114 24.6626 9.50396C26.182 10.5965 27.2699 12.1876 27.7368 13.9999H29.7983Z" fill="white"/>
                              <path d="M32 16H22C21.4698 16.0006 20.9614 16.2115 20.5865 16.5865C20.2115 16.9614 20.0006 17.4698 20 18V22H16C15.4698 22.0006 14.9614 22.2115 14.5865 22.5865C14.2115 22.9614 14.0006 23.4698 14 24V34H34V18C33.9994 17.4698 33.7885 16.9614 33.4135 16.5865C33.0386 16.2115 32.5302 16.0006 32 16ZM16 32V24H20V32H16ZM32 32H22V18H32V32Z" fill="white"/>
                              <path d="M26 20H24V24H26V20Z" fill="white"/>
                              <path d="M30 20H28V24H30V20Z" fill="white"/>
                              <path d="M26 26H24V30H26V26Z" fill="white"/>
                              <path d="M30 26H28V30H30V26Z" fill="white"/>
                              </g>
                              <defs>
                              <clipPath id="clip0_3020_31720">
                              <rect width="32" height="32" fill="white" transform="translate(4 4)"/>
                              </clipPath>
                              </defs>
                              </svg>

                              <div class="card-title">Customized solution for enterprise</div>
                            </div>
                            <div class="card-desc">
                              Provides customized reduction strategies that enable the enterprises to set their own carbon neutrality goals and achieve them.
                            </div>
                          </div>

                          <div class="card">
                            <div class="card-icon">
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="40" height="40" rx="12" fill="#232652"/>
                              <path d="M28.0004 13.547C27.9204 13.5337 27.8271 13.5337 27.7471 13.547C25.9071 13.4803 24.4404 11.9737 24.4404 10.107C24.4404 8.20033 25.9738 6.66699 27.8804 6.66699C29.7871 6.66699 31.3204 8.21366 31.3204 10.107C31.3071 11.9737 29.8404 13.4803 28.0004 13.547Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M26.6269 23.2538C28.4536 23.5605 30.4669 23.2405 31.8802 22.2938C33.7602 21.0405 33.7602 18.9872 31.8802 17.7338C30.4536 16.7872 28.4136 16.4672 26.5869 16.7872" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M11.9596 13.547C12.0396 13.5337 12.133 13.5337 12.213 13.547C14.053 13.4803 15.5196 11.9737 15.5196 10.107C15.5196 8.20033 13.9863 6.66699 12.0796 6.66699C10.173 6.66699 8.63965 8.21366 8.63965 10.107C8.65298 11.9737 10.1196 13.4803 11.9596 13.547Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M13.3333 23.2538C11.5066 23.5605 9.49325 23.2405 8.07992 22.2938C6.19992 21.0405 6.19992 18.9872 8.07992 17.7338C9.50659 16.7872 11.5466 16.4672 13.3733 16.7872" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M20.0005 23.507C19.9205 23.4937 19.8272 23.4937 19.7472 23.507C17.9072 23.4403 16.4404 21.9337 16.4404 20.067C16.4404 18.1603 17.9738 16.627 19.8805 16.627C21.7871 16.627 23.3205 18.1737 23.3205 20.067C23.3071 21.9337 21.8405 23.4537 20.0005 23.507Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M16.12 27.7065C14.24 28.9598 14.24 31.0132 16.12 32.2665C18.2533 33.6932 21.7467 33.6932 23.88 32.2665C25.76 31.0132 25.76 28.9598 23.88 27.7065C21.76 26.2932 18.2533 26.2932 16.12 27.7065Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              <div class="card-title">Solution for individuals</div>
                            </div>
                            <div class="card-desc">
                              Support public consumers to purchase carbon credits to reduce their carbon footprints.
                            </div>
                          </div>
                        </div>

                      </div>

                    </div>
                  </div>
                </section>

                <section className="fd_market" id="A3">
                  <div className="fd_con_title">
                    <h3 className="fd_con_title_h3">
                      <div class="min-titlef-blue"></div>Message from the Chairman
                    </h3>
                  </div>
                  <p className="fd_con_title_subtit">Pioneers of the Carbon-Negative Era: A Commitment to a Sustainable Future</p>

                  <div className="fd_con_bgpanel">
                    <div className="fd_con_pn_desc" style={{textAlign:"left"}}>
                      Greetings, and thank you for visiting the Climate Foundation.
                      <br/>
                      <br/>
                      Humanity today faces the critical challenge of achieving carbon neutrality (Net-Zero).<br/>
                      Yet, efforts to merely reduce emissions alone will not be enough to halt the acceleration of the climate crisis. To realize true carbon neutrality and ensure the safety of future generations, we must turn our attention to carbon-negative actions—the removal of carbon dioxide from the atmosphere (CDR, Carbon Dioxide Removal).
                      <br/>
                      <br/>
                      The Climate Foundation was established to build trust and promote the CDR sector within the Voluntary Carbon Market (VCM), while also fulfilling our broader social responsibility in addressing climate change.<br/>
                      We believe that only by advancing both carbon reduction and carbon removal in parallel can we meaningfully lower the concentration of CO₂ already emitted and thereby reduce the planet’s carbon balance.
                      <br/>
                      <br/>
                      <p>Our Core Vision</p>
                      <p>
                        <ul style={{listStyle:"disc"}}>
                          <li>Establish internationally recognized methodologies and certification standards</li>
                          <li>Develop CDR standards with the highest level of integrity</li>
                          <li>Operate carbon credit programs within the Voluntary Carbon Market</li>
                          <li>Encourage innovation in CDR technologies</li>
                          <li>Contribute to the establishment of VCM market norms</li>
                          <li>Ensure transparency and uphold social responsibility</li>
                        </ul>
                      </p>
                      In close collaboration with governments, industries, academia, and civil society, we will serve as a trusted engine driving the transition to a carbon-negative society. <br/>
                      We sincerely ask for your continued interest and support in the journey of the Climate Foundation.<br/>
                      Thank you.<br/>
                      <br/>
                      <p style={{textAlign:"center"}}>Cheol Lee Chairman, Climate Foundation</p>
                    </div>
                  </div>
                </section>

                <section className="fd_market" id="A4">
                  <div className="fd_con_title">
                    <h3 className="fd_con_title_h3">
                      <div class="min-titlef-blue"></div>History of the Climate Foundation
                    </h3>
                  </div>

                  <div className="fd_con_bgpanel">
                    <div class="vc_column_container">
                      <div class="vc_column-inner ">
                        <div class="wpb_wrapper">

                          <div class="history-content last-paragraph-no-margin">
                            <ul>
                              <p class="year">2025</p>
                              <li class="content">
                                <ul>
                                  <li>
                                    <strong>2025. 12</strong>
                                    <p>A non-profit charitable foundation officially approved by the Korean government to receive tax-deductible donations<br/></p>
                                  </li>
                                  <li>
                                    <strong>2025. 9</strong>
                                    <p>Approval by the Ministry of Environment for the establishment of the non-profit foundation Climate Foundation<br/></p>
                                  </li>
                                  <li>
                                    <strong>2025. 3</strong>
                                    <p>Launch briefing session for the Carbon Offset Credit Platform<br/></p>
                                  </li>
                                  <li>
                                    <strong>2025. 2</strong>
                                    <p>Formation of the Foundation Establishment Committee<br/></p>
                                  </li>
                                </ul>
                              </li>
                              
                            </ul>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="fd_market" id="A5">
                  <div className="fd_con_title">
                    <h3 className="fd_con_title_h3">
                      <div class="min-titlef-blue"></div>Organization Chart
                    </h3>
                  </div>

                  <div className="fd_con_bgpanel">
                    <div class="organization" style={{textAlign:"center"}}>
                      <img src="/assets/img/organization_eng.png"></img>
                    </div>
                    <br/>
                    <div class="organization_list">
                      <div class="list_1st" style={{paddingLeft:"30px"}}>
                        <dl>
                          <dt>- Board of Directors</dt>
                          <dd style={{fontSize: "16px"}}>According to the articles of association, the board consists of five members: the Chairperson, the Executive Director, and Directors.</dd>
                        </dl>
                      </div>

                      <div className="table-container">
                        <table className="custom-table">
                          <thead>
                            <tr style={{textAlign:"center"}}>
                              <th>Department</th>
                              <th>Name/Position</th>
                              <th>Affiliation</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td rowSpan="11" style={{textAlign:"center"}}>Board</td>
                              <td>Cheol Lee, Chairman</td>
                              <td>Climate Foundation Chairman</td>
                            </tr>
                            <tr>
                              <td>Kang Shin-gyeol, Executive Director</td>
                              <td>Climate Foundation</td>
                            </tr>
                            <tr>
                              <td>Choi Han-sang, Director</td>
                              <td>Climate Foundation</td>
                            </tr>
                            <tr>
                              <td>Jeong Young-min, Director</td>
                              <td>Climate Foundation</td>
                            </tr>
                            <tr>
                              <td>Kim Jong-sik, Director</td>
                              <td>Climate Foundation</td>
                            </tr>
                            <tr>
                              <td>Paek Seungduck, Auditor</td>
                              <td>Climate Foundation</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <br/>
                    <div class="organization_list">
                      <div class="list_1st" style={{paddingLeft:"30px"}}>
                        <dl>
                          <dt>- Operating Committee</dt>
                          <dd style={{fontSize: "16px"}}>To ensure the sustainable development and management of the Foundation, the Operating Committee is composed of experts with professional knowledge and experience. The committee develops and supports strategies for revitalizing the voluntary carbon market (VCM), secures carbon credits, and reviews and adjusts certification standards for carbon reduction.</dd>
                        </dl>
                      </div>

                      <div className="table-container">
                        <table className="custom-table">
                          <thead>
                            <tr style={{textAlign:"center"}}>
                              <th>Department</th>
                              <th>Name/Position</th>
                              <th>Affiliation</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td rowSpan="11" style={{textAlign:"center"}}>Operating Committee</td>
                              <td>Kim Young-choon, Chairman </td>
                              <td>(Former) Minister of Oceans and Fisheries</td>
                            </tr>
                            <tr>
                              <td>Do Jong-kwang, Member</td>
                              <td>Head of VCM Activation, CEO of Korea Infrastructure Development Co., Ltd.</td>
                            </tr>
                            <tr>
                              <td>Kim Chang-ho, Member</td>
                              <td>Partnership Development, CEO of Korea Local Governance Association</td>
                            </tr>
                            <tr>
                              <td>Hwang Yoo-heon, Member</td>
                              <td>Attorney, Law Firm ○○</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <br/>
                    <div class="organization_list">
                      <div class="list_1st" style={{paddingLeft:"30px"}}>
                        <dl>
                          <dt>- Certification Committee</dt>
                          <dd style={{fontSize: "16px"}}>The Certification Committee operates independently to certify emission reduction activities. It makes final decisions on methodology and project registration, and assumes responsibility for KCR issuance to ensure credibility.</dd>
                        </dl>
                      </div>

                      <div className="table-container">
                        <table className="custom-table">
                          <thead>
                            <tr style={{textAlign:"center"}}>
                              <th>Department</th>
                              <th>Name/Position</th>
                              <th>Affiliation</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td rowSpan="11" style={{textAlign:"center"}}>Certification Committee</td>
                              <td>Lee Jong-su, Certification Chairman</td>
                              <td>Professor, Head of Research, Seoul National University</td>
                            </tr>
                            <tr>
                              <td>Lee Min-ho, Member</td>
                              <td>Head of ESG Research Center, Yulchon LLC</td>
                            </tr>
                            <tr>
                              <td>Jung Chul-ho, Member</td>
                              <td>Patent Attorney, CEO of Nuri Patent & Law Firm</td>
                            </tr>
                            <tr>
                              <td>Lee Min-a, Member</td>
                              <td>Ph.D., Vice President, Newton Co., Ltd.</td>
                            </tr>
                            <tr>
                              <td>Wi Young-ho, Member</td>
                              <td>Ph.D., Director of Carbon-Free Research Institute, LowCarbon Inc.</td>
                            </tr>
                            <tr>
                              <td>Hwang Woo-sung, Member</td>
                              <td>Attorney, Law Firm ○○</td>
                            </tr>
                            <tr>
                              <td>Jun Ki-won, Ph.D.</td>
                              <td>Korea Research Institute of Chemical Technology</td>
                            </tr>
                            <tr>
                              <td>Kim Woo-hyun, Ph.D.</td>
                              <td>(Former) Korea Institute of Machinery & Materials</td>
                            </tr>
                            <tr>
                              <td>Lee Mi-hwa, CEO</td>
                              <td>The Korea Environmental Daily</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <br/>
                    <div class="organization_list">
                      <div class="list_1st" style={{paddingLeft:"30px"}}>
                        <dl>
                          <dt>- Secretariat</dt>
                          <dd style={{fontSize: "16px"}}>To address climate change and sustainable development, technical leadership, diversity, and a global mindset are required. The Secretariat will expand with experts worldwide.</dd>
                        </dl>
                      </div>

                      <div className="table-container">
                        <table className="custom-table">
                          <thead>
                            <tr style={{textAlign:"center"}}>
                              <th>Department</th>
                              <th>Name/Position</th>
                              <th>Duties</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style={{textAlign:"center"}}>Secretariat</td>
                              <td>Kim Hong-il, Director of Secretariat</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td style={{textAlign:"center"}}>Certification Group</td>
                              <td>Lee Ji-woong</td>
                              <td>- Development and certification of methodologies<br/>
                                  - Standard development and innovation</td>
                            </tr>
                            <tr>
                              <td style={{textAlign:"center"}}>Consulting Group</td>
                              <td>Park Eun-ji</td>
                              <td>- Carbon reduction and carbon removal project consulting<br/>
                                  - ESG management consulting</td>
                            </tr>
                            <tr>
                              <td style={{textAlign:"center"}}>Operations Group</td>
                              <td>Kim Hong-il</td>
                              <td>Marketing and communication</td>
                            </tr>
                            <tr>
                              <td style={{textAlign:"center"}}>Operations Group</td>
                              <td>Lee Jung-hak</td>
                              <td>Market development and external affairs</td>
                            </tr>
                            <tr>
                              <td style={{textAlign:"center"}}>Operations Group</td>
                              <td>Lee Young-mook</td>
                              <td>Operations and technical support</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div style={{paddingLeft: "30px"}}>
                      <div style={{fontWeight: "600"}}>- External Partners</div>
                      <div>
                        <ul style={{listStyle:"disc", fontSize: "15px", padding: "20px 0 0 20px"}}>
                          <li>Global CCUS Society</li>
                          <li>KCCUS Research Institute</li>
                          <li>Korea ESG Society</li>
                        </ul>
                      </div>
                    </div>

                  </div>
                </section>

              </div>
            )}
          
           {/*}<div className="col-lg-8 offset-lg-2" style={{ wordBreak: "keep-all" }}> 
            {/* {props.language == "ko" && <FoundationKo />}
            {props.language == "en" && <FoundationEn />} */}
            {/*}
            {props.language == "ko" && (
              <img
                src={krImage}
                style={{
                  width: "100%",
                  background:
                    "linear-gradient(to bottom, white 50%, transparent 50%)",
                  position: "relative",
                  zIndex: 2,
                }}
              />
            )}
            {props.language == "en" && (
              <img
                src={enImage}
                style={{
                  width: "100%",
                  background:
                    "linear-gradient(to bottom, white 50%, transparent 50%)",
                  position: "relative",
                  zIndex: 2,
                }}
              />
            )}
            {*/}
          {/*}</div>{*/}
        {/*}</div>{*/}
      </div>
      <div className="cs-height_60 cs-height_lg_30"></div>
      <div className="fd_bottom"></div>
    </div>
  );
}
export default connect((state) => {
  return {
    language: state.language,
  };
})(PrivacyPolicy);
